module.exports = __webpack_public_path__ + "img/depmap_svg_V134.88e9a2b5.svg";